import { eEndorsements } from '../../../../ui-toolkit/enums/eEndorsements';

export interface IFlatEndorsementFeeResponse {
  name: eEndorsements;
  fee: number;
}

export type IFlatEndorsementFeeData = IFlatEndorsementFeeResponse;

export const convertIFlatEndorsementFeeResponseToIFlatEndorsementFeeData = (
  response: IFlatEndorsementFeeResponse
): IFlatEndorsementFeeData => ({ ...response });
